export const TABLET_WIDTH = 768;
export const DESKTOP_WIDTH = 1200;



// WEBPACK FOOTER //
// ./src/constants/breakPoints.js